import { render, staticRenderFns } from "./GroupsView.vue?vue&type=template&id=b57a856a&scoped=true&"
import script from "./GroupsView.vue?vue&type=script&lang=js&"
export * from "./GroupsView.vue?vue&type=script&lang=js&"
import style0 from "./GroupsView.vue?vue&type=style&index=0&id=b57a856a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57a856a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
